import React, { Component, KeyboardEvent } from "react";
import Strings from "@my-dld/assets/strings";
import { ILoginComponent, LoginType } from "./index";
import { ILoader } from "../index";
import { ServerDate, StringUtil } from "@eres/core";
import { Entities, IdentityApi } from "@10x/dubai-rest-api";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import MobileConverter from "@my-dld/components/Form/Converters/MobileConverter";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { MobileInputClassProvider } from "@my-dld/components/FixedEidInput";
import DateInputField from "@eres/forms-web/DateInputField";
import StateHolder from "@eres/forms/StateHolder";
import { ErrorContainer } from "@eres/forms";
import { showErrorMessage } from "@my-dld/utils/UIUtils";

interface State {
	mobile?: string;
	dob?: ServerDate;
	errorContainer: ErrorContainer;
}

export function MobileStateFormatter( eid: string ) {
	return "+" + eid.replace( /\D/g, "" );//eid.replace(/_/g, "").replace(/-/g, "").replace(/\s/g, "");
}

export class MobileLogin extends Component<any, State> implements ILoginComponent<any, State> {
	today = new Date();

	constructor( props: any ) {
		super( props );
		this.state = {
			errorContainer: {},
			mobile: "+971" //"+971-58-2479398",
		};
	}

	render() {
		const ds = StateHolder.buildStateHolder( this );
		return (
			<>
				<TextInputField
					containerClassName={ "form-group" }
					inputClassName={ "form-control ltr-text-field" }
					placeHolder={ "+971-5X-XXXXXXX" }
					id={ "mobile" }
					required={ true }
					holder={ this }
					error={ this.state.errorContainer?.mobile }
					label={ Strings.registered_mobile_number }
					maxLength={ 15 }
					inputProps={ { onKeyPress: this.onKeyUp } }
					converter={ MobileConverter }
					inputClassProvider={ MobileInputClassProvider }
				>
				</TextInputField>
				<DateInputField
					containerClassName={ "field-style form-group-icon" }
					required={ true }
					holder={ ds }
					label={ Strings.date_of_birth }
					id={ "dob" }
					extraOpts={ {
						maxDate: this.today,
						yearRange: "-100:+0"
					} }
				/>
			</>
		);
	}

	onKeyUp = ( event: KeyboardEvent<any> ) => {
		if ( event.charCode === 13 ) {
			this.props.doLogin();
		}
	};
	doLogin = ( loader: ILoader ) => {
		loader.setLoading( true );
		let isValid = true;
		const errorContainer: ErrorContainer = {};
		let mobile = this.state.mobile ? this.state.mobile! : undefined;
		mobile = mobile?.replace( /\s/, "" );
		if ( StringUtil.isEmptyStringOrNull( mobile ) ) {
			isValid = false;
			errorContainer.mobile = Strings.please_enter_valid_phone_number;
		} else if ( mobile?.length !== 15 ) {
			isValid = false;
			errorContainer.mobile = Strings.please_enter_valid_phone_number;
		}
		if ( StringUtil.isEmptyStringOrNull( this.state.dob ) ) {
			errorContainer[ "dob" ] = Strings.please_enter_dob;
			isValid = false;
		}
		this.setState( { errorContainer: errorContainer } );
		if ( isValid ) {
			let mobile = this.state.mobile!;
			trackEventWithData( "Login", "TryLogin", { method: "Mobile", id: mobile } );
			let parts = mobile.split( "-" );
			for ( let i = 0; i < parts.length; i++ ) {
				parts[ i ] = parts[ i ].replace( /[^0-9]/g, "" );
			}
			mobile = parts.join( "|" );
			return IdentityApi.loginByMobile( mobile, this.state.dob! )
			.then( Entities.validateResponse )
			.then( profile => {
				loader.setLoading( false );
				return {
					result: profile,
					method: "Mobile" as LoginType,
					id: mobile,
					dob: this.state.dob!
				};
			} )
			.catch( e => {
				loader.setLoading( false );
				showErrorMessage( e );
				return Promise.reject();
			} );
		}
		loader.setLoading( false );
		return Promise.reject();
	};
}
